import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';

import { SharePermissionField } from './shareAccessHelpers';
import { ShareAccessTableRow } from './ShareAccessTableRow';
import { ReportAccessData } from '../../../../../@types';

/** Matches HEADER_SX on the My Reports table this dialog opens from. */
const HEADER_SX = {
  fontSize: '10px',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px',
  fontWeight: 600,
  whiteSpace: 'nowrap' as const,
  py: 0.75,
  px: 1,
  borderBottom: '2px solid',
  borderColor: 'v4.border',
} as const;

export interface ShareAccessTableProps {
  rows: ReportAccessData[];
  onTogglePermission: (
    entityId: number | undefined,
    field: SharePermissionField,
    checked: boolean
  ) => void;
  onRemove: (row: ReportAccessData) => void;
}

export const ShareAccessTable: React.FC<ShareAccessTableProps> = ({
  rows,
  onTogglePermission,
  onRemove,
}) => (
  <Table size="small">
    <TableHead>
      <TableRow sx={{ bgcolor: 'v4.tableEven' }}>
        <TableCell sx={HEADER_SX}>Name</TableCell>
        <TableCell sx={HEADER_SX}>Permissions</TableCell>
        <TableCell sx={{ ...HEADER_SX, width: 48 }} aria-label="Actions" />
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.length === 0 ? (
        <TableRow>
          <TableCell colSpan={3} sx={{ px: 1, py: 3, borderBottom: 'none' }}>
            <Typography variant="caption" sx={{ color: 'v4.textFaint' }}>
              No one has been given access yet. Search above to share this report.
            </Typography>
          </TableCell>
        </TableRow>
      ) : (
        rows.map((row, index) => (
          <ShareAccessTableRow
            key={row.entityId}
            row={row}
            even={index % 2 === 0}
            onTogglePermission={(field, checked) =>
              onTogglePermission(row.entityId, field, checked)
            }
            onRemove={() => onRemove(row)}
          />
        ))
      )}
    </TableBody>
  </Table>
);
